export const fundOverview = {
  totalIncome: 1285600,
  totalExpense: 1156800,
  managementFeeRate: 3.2,
  expenseCategories: [
    { name: '物资采购', value: 856000, percentage: 74 },
    { name: '物流配送', value: 185000, percentage: 16 },
    { name: '运营管理', value: 92800, percentage: 8 },
    { name: '宣传推广', value: 23000, percentage: 2 }
  ],
  // 月度发放趋势数据 - 有起伏
  monthlyTrend: [
    { month: '1月', value: 45000 },
    { month: '2月', value: 38000 },
    { month: '3月', value: 52000 },
    { month: '4月', value: 68000 },
    { month: '5月', value: 85000 },
    { month: '6月', value: 125000 },
    { month: '7月', value: 156000 },
    { month: '8月', value: 142000 },
    { month: '9月', value: 98000 },
    { month: '10月', value: 72000 },
    { month: '11月', value: 58000 },
    { month: '12月', value: 48000 }
  ]
};

export const reports = [
  {
    id: 1,
    period: '2024年第四季度',
    title: '2024年第四季度财务报告',
    date: '2025-01-15',
    size: '2.3 MB',
    type: 'quarterly',
    url: '#'
  },
  {
    id: 2,
    period: '2024年12月',
    title: '2024年12月执行报告',
    date: '2025-01-05',
    size: '1.8 MB',
    type: 'monthly',
    url: '#'
  },
  {
    id: 3,
    period: '2024年11月',
    title: '2024年11月执行报告',
    date: '2024-12-05',
    size: '1.6 MB',
    type: 'monthly',
    url: '#'
  },
  {
    id: 4,
    period: '2024年第三季度',
    title: '2024年第三季度财务报告',
    date: '2024-10-15',
    size: '2.1 MB',
    type: 'quarterly',
    url: '#'
  },
  {
    id: 5,
    period: '2024年10月',
    title: '2024年10月执行报告',
    date: '2024-11-05',
    size: '1.7 MB',
    type: 'monthly',
    url: '#'
  },
  {
    id: 6,
    period: '2024年9月',
    title: '2024年9月执行报告',
    date: '2024-10-05',
    size: '1.5 MB',
    type: 'monthly',
    url: '#'
  }
];

export const distributionRecords = [
  {
    id: 1,
    date: '2025-01-20',
    location: '渝中区解放碑',
    recipient: '渝中区环卫中心',
    bottles: 480,
    receiver: '张主任',
    proof: 'https://readdy.ai/api/search-image?query=A%20professional%20photo%20showing%20bottled%20water%20distribution%20receipt%20document%20with%20official%20stamps%20and%20signatures%20on%20white%20paper%20clean%20background%20documentary%20style%20high%20quality%20realistic%20lighting&width=200&height=150&seq=proof1&orientation=landscape'
  },
  {
    id: 2,
    date: '2025-01-19',
    location: '江北区观音桥',
    recipient: '顺丰速运江北站',
    bottles: 360,
    receiver: '李站长',
    proof: 'https://readdy.ai/api/search-image?query=A%20clear%20photo%20of%20delivery%20confirmation%20form%20with%20handwritten%20signatures%20and%20company%20seal%20on%20official%20document%20simple%20white%20background%20professional%20documentation%20style%20sharp%20focus&width=200&height=150&seq=proof2&orientation=landscape'
  },
  {
    id: 3,
    date: '2025-01-18',
    location: '南岸区南坪',
    recipient: '美团外卖南岸配送站',
    bottles: 420,
    receiver: '王经理',
    proof: 'https://readdy.ai/api/search-image?query=A%20professional%20photograph%20of%20signed%20receipt%20paper%20with%20official%20company%20stamp%20and%20multiple%20signatures%20clean%20white%20background%20documentary%20photography%20style%20well%20lit&width=200&height=150&seq=proof3&orientation=landscape'
  },
  {
    id: 4,
    date: '2025-01-17',
    location: '沙坪坝区三峡广场',
    recipient: '沙坪坝区城管局',
    bottles: 540,
    receiver: '赵科长',
    proof: 'https://readdy.ai/api/search-image?query=A%20high%20quality%20photo%20showing%20official%20distribution%20receipt%20document%20with%20red%20stamps%20and%20signatures%20on%20white%20paper%20clean%20simple%20background%20professional%20style&width=200&height=150&seq=proof4&orientation=landscape'
  },
  {
    id: 5,
    date: '2025-01-16',
    location: '九龙坡区杨家坪',
    recipient: '中通快递九龙坡分部',
    bottles: 300,
    receiver: '刘主管',
    proof: 'https://readdy.ai/api/search-image?query=A%20clear%20photograph%20of%20signed%20delivery%20form%20with%20official%20stamps%20and%20handwritten%20names%20on%20white%20document%20simple%20background%20documentary%20style%20sharp%20details&width=200&height=150&seq=proof5&orientation=landscape'
  },
  {
    id: 6,
    date: '2025-01-15',
    location: '渝北区龙溪',
    recipient: '饿了么渝北配送中心',
    bottles: 390,
    receiver: '陈站长',
    proof: 'https://readdy.ai/api/search-image?query=A%20professional%20photo%20of%20receipt%20confirmation%20document%20with%20company%20seal%20and%20signatures%20on%20clean%20white%20paper%20simple%20background%20high%20quality%20documentation%20style&width=200&height=150&seq=proof6&orientation=landscape'
  },
  {
    id: 7,
    date: '2025-01-14',
    location: '大渡口区新山村',
    recipient: '大渡口区环卫所',
    bottles: 450,
    receiver: '周主任',
    proof: 'https://readdy.ai/api/search-image?query=A%20detailed%20photo%20showing%20official%20receipt%20paper%20with%20red%20official%20stamps%20and%20multiple%20signatures%20white%20background%20professional%20documentary%20photography%20clear%20focus&width=200&height=150&seq=proof7&orientation=landscape'
  },
  {
    id: 8,
    date: '2025-01-13',
    location: '巴南区李家沱',
    recipient: '京东物流巴南站',
    bottles: 330,
    receiver: '吴经理',
    proof: 'https://readdy.ai/api/search-image?query=A%20high%20resolution%20photo%20of%20signed%20distribution%20form%20with%20official%20company%20stamps%20and%20handwritten%20signatures%20on%20white%20document%20clean%20background%20professional%20style&width=200&height=150&seq=proof8&orientation=landscape'
  }
];

export const auditReports = [
  {
    id: 1,
    title: '2024年度审计报告',
    date: '2025-01-10',
    auditor: '重庆市德勤会计师事务所',
    thumbnail: '',
    url: '#'
  },
  {
    id: 2,
    title: '2023年度审计报告',
    date: '2024-01-15',
    auditor: '重庆市德勤会计师事务所',
    thumbnail: '',
    url: '#'
  }
];

export const donorList = [
  { id: 1, name: '爱心人士', amount: 199, date: '2025-01-20 14:32', isAnonymous: false },
  { id: 2, name: '匿名', amount: 399, date: '2025-01-20 13:45', isAnonymous: true },
  { id: 3, name: '张**', amount: 999, date: '2025-01-20 11:20', isAnonymous: false },
  { id: 4, name: '李明', amount: 199, date: '2025-01-20 10:15', isAnonymous: false },
  { id: 5, name: '匿名', amount: 99, date: '2025-01-20 09:30', isAnonymous: true },
  { id: 6, name: '王**', amount: 399, date: '2025-01-19 16:45', isAnonymous: false },
  { id: 7, name: '重庆某科技公司', amount: 9999, date: '2025-01-19 15:20', isAnonymous: false },
  { id: 8, name: '匿名', amount: 199, date: '2025-01-19 14:10', isAnonymous: true },
  { id: 9, name: '赵**', amount: 199, date: '2025-01-19 11:30', isAnonymous: false },
  { id: 10, name: '刘芳', amount: 399, date: '2025-01-19 10:05', isAnonymous: false },
  { id: 11, name: '匿名', amount: 999, date: '2025-01-18 17:20', isAnonymous: true },
  { id: 12, name: '陈**', amount: 199, date: '2025-01-18 15:40', isAnonymous: false },
  { id: 13, name: '某爱心企业', amount: 19999, date: '2025-01-18 14:15', isAnonymous: false },
  { id: 14, name: '匿名', amount: 99, date: '2025-01-18 13:25', isAnonymous: true },
  { id: 15, name: '周**', amount: 399, date: '2025-01-18 11:50', isAnonymous: false }
];

export const districts = [
  '全部区域',
  '渝中区',
  '江北区',
  '南岸区',
  '沙坪坝区',
  '九龙坡区',
  '渝北区',
  '大渡口区',
  '巴南区',
  '北碚区',
  '綦江区',
  '长寿区',
  '江津区',
  '合川区',
  '永川区',
  '南川区',
  '璧山区',
  '铜梁区',
  '潼南区',
  '荣昌区',
  '开州区',
  '梁平区',
  '武隆区'
];